<script lang="ts">
	import type { Writable } from 'svelte/store';
	import type { Hub } from '$lib/api/rpc';

	export let hub: Writable<Hub>;
</script>

<p class="px-hub-description" style={`color: ${$hub.theme.coverFontColor}`}>
	{$hub.description}
</p>

<style>
	p {
		display: flex;
		justify-content: center;
		margin: var(--gutterSmall);
		font-size: var(--fontSizeSmall);
		white-space: nowrap;
	}
</style>
